import React from "react";
import { Box, Heading, Hide } from "@catchoftheday/cg-components";
import { DesktopWrapper } from "./DesktopWrapper";
import { MobileWrapper } from "./MobileWrapper";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Benefits = function Benefits() {
  return ___EmotionJSX(Box, {
    mb: {
      xs: 10,
      md: 20
    }
  }, ___EmotionJSX(Heading.h4, {
    mb: {
      xs: 2,
      md: 4
    },
    color: "onePass.textPrimary",
    fontWeight: "bold"
  }, "You'll get access to:"), ___EmotionJSX(Hide, {
    md: true,
    lg: true,
    xl: true
  }, ___EmotionJSX(MobileWrapper, null)), ___EmotionJSX(Hide, {
    xs: true,
    sm: true
  }, ___EmotionJSX(DesktopWrapper, null)));
};